@if (data(); as d) {
  @let $editing = editing();
  @let $taxRate = taxRate();

  <ng-template #headerEnd>
    @if ($editing) {
      <calcite-action
        text="Save"
        text-enabled
        scale="m"
        icon="check"
        class="app-success"
        [disabled]="!$taxRate.valid"
        (click)="save()"
      />
      @if (d.tax_rate !== null) {
        <calcite-action
          text="Cancel"
          text-enabled
          scale="m"
          icon="x"
          class="app-danger"
          (click)="cancel()"
        />
      }
    } @else {
      <calcite-action
        text="Edit"
        text-enabled
        scale="m"
        icon="pencil"
        (click)="editing.set(true)"
      />
    }
    @if (d.source && !$editing) {
      @if (d.has_source) {
        <calcite-action
          text="View Bill"
          text-enabled
          scale="m"
          icon="file-pdf"
          (click)="viewBill()"
        />
      }
      <calcite-action
        text="Refresh"
        text-enabled
        class="app-danger"
        scale="m"
        icon="refresh"
        (click)="refresh()"
      />
    }
  </ng-template>

  <div class="tax-bill-grid">
    <div>
      <label class="app-field">
        <span>Tax Rate</span>
        @if ($editing) {
          <calcite-input-number
            suffix-text="%"
            placeholder="—"
            number-button-type="none"
            [value]="$taxRate.stringValue"
            (calciteInputNumberChange)="updateTaxRate($event.target.value)"
          />
        } @else {
          <div>{{ $taxRate.stringValue }}</div>
        }
      </label>
    </div>

    <div>
      @if (d.error) {
        <calcite-notice open kind="warning" icon="exclamation-mark-triangle" width="full">
          <div slot="title">Automatic retrieval failed</div>
          <div slot="message">{{ d.error }}</div>
        </calcite-notice>
      }

      @if ($editing) {
        @if (d.fallback_url) {
          <calcite-button appearance="solid" width="half" icon-end="launch" (click)="openFallbackUrl()">
            Open county tax portal
          </calcite-button>
        } @else {
          <calcite-notice open kind="info" icon="information" width="full">
            Automatic retrieval isn't available for this county yet. Upload the bill yourself
            below.
          </calcite-notice>
        }

        <app-file-drop-zone
          #dropZone
          [accept]="uploadAccept()"
          documentType="Tax Bill"
          (fileSelected)="onFileSelected($event)"
        >
          @if (imageUrl()) {
            <img [src]="imageUrl()" alt="Detail of taxes due snapshot" class="tax-bill-image thumbnail"/>
          }
        </app-file-drop-zone>
      } @else {
        <calcite-alert kind="info" icon="information">
          {{ d.source === 'auto' ? 'Automatically retrieved from the county.' : 'Uploaded by you.' }}
        </calcite-alert>

        @if (imageUrl()) {
          <img [src]="imageUrl()" alt="Detail of taxes due snapshot" class="tax-bill-image"/>
        }
      }
    </div>
  </div>
}
